export default function CTA() {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20real%20estate%20consultation%20scene%20with%20modern%20office%20interior%20and%20warm%20atmosphere%2C%20business%20meeting%20environment%20with%20sophisticated%20design%20and%20natural%20lighting%2C%20customer%20service%20setting%20with%20clean%20and%20elegant%20composition%2C%20welcoming%20consultation%20space%20with%20refined%20aesthetic%20and%20studio%20quality%20photography&width=1920&height=1080&seq=cta-bg-001&orientation=landscape"
          alt="CTA Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative h-full flex flex-col items-center justify-center text-center px-6">
        {/* Main Title */}
        <h2 className="text-6xl lg:text-7xl font-black text-white mb-8 tracking-wide">
          無料相談を予約する
        </h2>

        {/* Subtitle */}
        <div className="mb-12">
          <p className="text-white text-xl lg:text-2xl font-light mb-2">
            まずはお気軽にご相談ください
          </p>
          <p className="text-white text-xl lg:text-2xl font-light">
            専門スタッフが丁寧に対応いたします
          </p>
        </div>

        {/* CTA Button */}
        <button className="relative inline-flex items-center bg-gray-900 text-white rounded-full pl-2 pr-8 py-2 hover:bg-gray-800 transition-all group cursor-pointer whitespace-nowrap">
          {/* White Circle with Phone Icon */}
          <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mr-4">
            <i className="ri-phone-line text-gray-900 text-xl"></i>
          </div>
          
          {/* Button Text */}
          <span className="text-lg font-bold tracking-wide">今すぐ予約</span>
          
          {/* Arrow Icon */}
          <i className="ri-arrow-right-up-line text-white text-xl ml-4"></i>
        </button>
      </div>
    </section>
  );
}
